import type { ColourVariant } from "@shared/ui.design-system";
import Markdown from "markdown-to-jsx";
import type { ComponentType } from "react";
import React from "react";

import { Typography } from "../Typography/Typography";
import type {
  TextVariants,
  TypographyProps
} from "../Typography/Typography.types";

import * as styles from "./MarkdownContainer.css";

type Props = {
  content: string;
  tagOverrides?: {
    [key: string]: {
      component: ComponentType<TypographyProps>;
      props: {
        as?: string;
        target?: string;
        variant: TextVariants;
        colour?: ColourVariant;
        underline?: boolean;
      };
    };
  };
  forceBlock?: boolean;
};

const defaultOverrides = {
  a: {
    component: Typography,
    props: {
      as: "a",
      target: "_blank",
      rel: "noopener noreferrer",
      underline: true
    }
  },
  b: {
    component: Typography,
    props: {
      as: "strong",
      variant: "body-md",
      colour: "primary-medium"
    }
  },
  h2: {
    component: Typography,
    props: {
      as: "h4",
      variant: "subheader-6",
      colour: "primary-dark"
    }
  },
  li: {
    component: Typography,
    props: {
      as: "li",
      variant: "body-md",
      colour: "primary-medium"
    }
  },
  p: {
    component: Typography,
    props: {
      as: "p",
      variant: "body-md",
      colour: "primary-medium"
    }
  },
  span: {
    component: Typography,
    props: {
      as: "span",
      variant: "body-md",
      colour: "primary-medium"
    }
  }
};

export const MarkdownContainer: React.FC<Props> = ({
  content,
  tagOverrides = undefined,
  forceBlock = false
}) => {
  return (
    <Markdown
      className={styles.markdownContainer}
      options={{
        overrides: tagOverrides ?? defaultOverrides,
        forceBlock
      }}
    >
      {content}
    </Markdown>
  );
};
